/**
 * [라이브 회의 경로 판정] — "갑자기 튕김" 근본 수정의 순수 로직.
 *
 * 회의 중(라이브 in-room 세션 생존) 발생하는 401/403/선제-만료는 원래
 * `redirectToLogin()`의 하드 네비게이션(`window.location.href`)으로 페이지를
 * 언로드시켜 참가자를 튕겨냈다. 이 함수는 "지금 라이브 회의 경로인가?"를 판정하여
 * redirectToLogin 내부에서 그 하드 네비를 억제(격하)할지 결정하는 데 쓰인다.
 *
 * 판정 규칙: **첫 경로 세그먼트가 `meeting` 또는 `rooms`** 인 경우에만 라이브 회의.
 * - `startsWith('/meeting')`를 쓰지 않는다 — `/meetings/{id}/edit`(비회의) 오판 방지.
 * - 연결 전 경로(`/join`, `/prejoin`)와 대기 상태(대기는 `/join`에서 발생)는 보호할
 *   라이브 세션이 없으므로 false(기존대로 하드 리다이렉트해도 무방).
 *
 * @param pathname `window.location.pathname` 등 경로 문자열(쿼리/해시 포함 가능). null/undefined 방어.
 * @returns 라이브 회의(in-room) 경로면 true.
 */
export function isLiveMeetingPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;

  // 쿼리(?)·해시(#) 방어적 제거 후 선행 슬래시 제거, 첫 세그먼트만 추출.
  const path = pathname.split(/[?#]/, 1)[0];
  const firstSegment = path.replace(/^\/+/, '').split('/', 1)[0];

  return firstSegment === 'meeting' || firstSegment === 'rooms';
}
